<template>
  <div class="h-100 p-0 m-0">
    <div class="col-12 p-0 m-0">
      <div class="card padding-20">
        <div class="row p-0 m-0 mb-3 align-items-center justify-content-between">
          <div class="col-md-6 p-0">
            <h4 class="m-0 font-weight-bold">Ստորաբաժանումներ</h4>
          </div>
          <div class="col-md-6 p-0 text-right">
            <button class="btn btn-primary" @click="$router.push('/organisation-units/create')">
              <i class="fa fa-plus mr-1"></i>  Ավելացնել ստորաբաժանումներ
            </button>
          </div>
        </div>

        <!-- v-server-table -->
        <div class="table-responsive">
          <v-server-table
            ref="unitsTable"
            :url="tableUrl"
            :columns="columns"
            :options="options"
          >
            <!-- Name -->
            <div slot="name" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <span class="font-weight-medium">{{ row.name }}</span>
            </div>

            <!-- Users count -->
            <div slot="users_count" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <span class="badge badge-info px-2 py-1 font-weight-normal" style="font-size: 0.85rem;">
                {{ row.users_count }}
              </span>
            </div>

            <!-- Created at -->
            <div slot="created_at" slot-scope="{ row }" class="d-flex align-items-center h-100 text-muted">
              {{ row.created_at || '—' }}
            </div>

            <!-- Actions -->
            <div slot="actions" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <button
                class="btn btn-sm btn-outline-primary"
                @click="$router.push('/organisation-units/edit/' + row.id)"
                title="Խմբագրել"
              >
                <i class="fa fa-edit mr-1"></i> Խմբագրել
              </button>
            </div>
          </v-server-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganisationUnitsList',
  data() {
    return {
      tableUrl: `${process.env.VUE_APP_API_URL}organisation-units`,
      columns: ['id', 'name', 'users_count', 'created_at', 'actions'],
      options: {
        perPage: 10,
        perPageValues: [5, 10, 25, 50],
        sortable: ['id', 'name', 'created_at'],
        columnsDropdown: false,
        filterByColumn: false,
        skin: 'table table-bordered table-hover',
        pagination: { chunk: 5 },
        headings: {
          id: '#',
          name: 'Անվանում',
          users_count: 'Օգտատերերի քանակ',
          created_at: 'Ստեղծման ամսաթիվ',
          actions: 'Գործողություն',
        },
        texts: {
          count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count}֊ից|{count} ստորաբաժանում|',
          first: 'Առաջին',
          last: 'Վերջին',
          filter: '',
          filterPlaceholder: 'Որոնել...',
          limit: '',
          page: 'Էջ՝',
          noResults: 'Ստորաբաժանումներ չեն գտնվել',
          filterBy: 'Ֆիլտրել ըստ {column}֊ի',
          loading: 'Բեռնվում է...',
          defaultOption: 'Ընտրել {column}',
          columns: 'Սյուներ',
        },
        requestAdapter(data) {
          return {
            limit: data.limit ? data.limit : 10,
            page: data.page,
            query: data.query,
            orderBy: data.orderBy,
            ascending: data.ascending,
            byColumn: data.byColumn,
          }
        },
        responseAdapter({ data }) {
          return {
            data: data.data || [],
            count: data.count || 0,
          }
        },
        requestFunction(data) {
          return this.$client
            .get(this.url, { params: data })
            .catch(function (e) {
              this.dispatch('error', e)
            }.bind(this))
        },
      },
    }
  },
}
</script>

<style scoped>
.badge-info {
  background-color: #17a2b8;
  color: #fff;
}
</style>
